<template>
    <div
        :class="{
            'mds-modal--open': isVisible,
            'mds-modal--active': isAnimationVisible,
            'mds-modal--width-1200px': size === '1200px',
            'mds-modal--width-900px': size === '900px',
            'mds-modal--width-600px': size === '600px'
        }"
        class="mds-modal"
        tabindex="-1"
    >
        <div
            v-if="isVisible"
            :class="{'mds-overlay--active': isAnimationVisible}"
            class="mds-overlay"
            @mousedown="handleBackgroundClick"
        />
        <div class="mds-modal__wrapper">
            <section
                :aria-labelledby="ariaLabelledby"
                :aria-describedby="ariaDescribedby"
                :aria-hidden="isVisible ? 'false' : 'true'"
                :style="customWidthStyle"
                role="dialog"
                class="mds-modal__container"
            >
                <div :style="{overflow: overflow ? 'visible' : 'hidden'}" class="mds-modal__inner">
                    <header :class="{'mds-modal__header--no-title': !title}" class="mds-modal__header">
                        <div class="mds-modal__actions">
                            <slot name="actions"/>
                            <button
                                v-if="dismissible"
                                class="mds-button mds-button--icon-only"
                                type="button"
                                role="button"
                                @click="changeVisibility(false)"
                            >
                                <remove-icon class="mds-icon mds-button__icon mds-button__icon--left" />
                            </button>
                        </div>
                        <h1 class="mds-modal__title">{{ title }}</h1>
                    </header>
                    <div :style="{overflow: overflow ? 'visible' : 'hidden'}" class="mds-modal__content">
                        <slot/>
                    </div>
                </div>
            </section>
        </div>
    </div>
</template>

<script>
// eslint-disable-next-line
import CaretDownIcon from 'morningstar-design-system/dist/mds.svg?caret-down--s';
// eslint-disable-next-line
import RemoveIcon from 'morningstar-design-system/dist/mds.svg?remove';

export default {
    name: 'base-modal',
    components: {
        CaretDownIcon, RemoveIcon
    },
    props: {
        title: {
            type: String,
            default: ''
        },
        ariaLabelledby: {
            type: String,
            default: ''
        },
        ariaDescribedby: {
            type: String,
            default: ''
        },
        size: {
            type: String,
            default: '900px',
            validator(size) {
                return /^[0-9]+px$/gi.test(size);
            }
        },
        visible: {
            type: Boolean,
            default: false
        },
        dismissible: {
            type: Boolean,
            default: true
        },
        overflow: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            isVisible: this.visible,
            isAnimationVisible: false,
        };
    },
    computed: {
        customWidthStyle() {
            return ['600px', '900px', '1200px'].every(s => s !== this.size)
                ? { maxWidth: this.size }
                : undefined;
        }
    },
    watch: {
        visible(visible) {
            if (this.isVisible !== visible) {
                this.changeVisibility(visible);
            }
        },
    },
    mounted() {
        this.hasAlreadyExistedBodyOverlay = !!document.body.querySelector('.mds-body-overlay');
    },
    methods: {
        handlePressEscapeEvent(ev) {
            if (ev.keyCode === 27) {
                this.changeVisibility(false);
            }
        },
        handleBackgroundClick() {
            if (this.dismissible) {
                this.changeVisibility(false);
            }
        },
        changeVisibility(isVisible) {
            this.removeDismissEvents();
            if (isVisible) {
                this.isVisible = true;
                this.$nextTick(() => {
                    setTimeout(() => {
                        this.isAnimationVisible = true;
                    }, 200);
                });
                this.attachDismissEvents();
            } else {
                this.isAnimationVisible = false;
                this.$nextTick(() => {
                    setTimeout(() => {
                        this.isVisible = false;
                        this.$emit('close', false);
                    }, 500);
                });
            }
            this.changeBodyOverlay(isVisible);
        },
        removeDismissEvents() {
            window.document.removeEventListener('keydown', this.handlePressEscapeEvent);
        },
        attachDismissEvents() {
            if (this.dismissible) {
                window.document.addEventListener('keydown', this.handlePressEscapeEvent, { once: true });
            }
        },
        changeBodyOverlay(isVisible) {
            if (this.hasAlreadyExistedBodyOverlay) {
                return;
            }
            if (isVisible) {
                window.document.body.classList.add('mds-body-overlay');
            } else {
                window.document.body.classList.remove('mds-body-overlay');
            }
        }
    }
};
</script>
